import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from 'react-router-dom';
import { ArrowLeft, BookOpen } from 'lucide-react';

const Tutorials = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-roundone-dark-purple py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <Link 
              to="/"
              className="inline-flex items-center mb-6 text-roundone-light-purple hover:text-white transition-colors"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Tutorials & Guides</h1>
            <p className="text-lg text-roundone-white/80 max-w-3xl">
              Learn how to get the most out of RoundOne with our comprehensive tutorials and guides.
              We'll be adding new content regularly to help you succeed.
            </p>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto">
          {/* Coming Soon Message */}
          <Card className="mb-12">
            <CardContent className="pt-6 flex flex-col items-center justify-center text-center py-16">
              <BookOpen className="h-16 w-16 text-roundone-purple mb-4" />
              <h2 className="text-2xl font-bold mb-2">Tutorials Coming Soon</h2>
              <p className="text-muted-foreground max-w-2xl">
                We're currently developing comprehensive tutorials and guides to help you make the most of RoundOne.
                Check back soon for helpful content!
              </p>
            </CardContent>
          </Card>

          {/* Placeholder for Future Tutorial Categories */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              'Getting Started with RoundOne',
              'Creating Effective Assessments',
              'Analyzing Assessment Results',
              'Managing Candidates',
              'Integrations & API',
              'Advanced Features'
            ].map((category, index) => (
              <Card key={index} className="cursor-not-allowed opacity-70 hover:opacity-80 transition-opacity">
                <CardHeader className="pb-2">
                  <CardTitle>{category}</CardTitle>
                  <CardDescription>Coming soon</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground">
                    Our team is creating helpful content for this section.
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Request Custom Tutorial Section */}
          <div className="mt-16 p-8 rounded-lg bg-slate-50 border border-slate-200">
            <h2 className="text-2xl font-bold mb-2">Need Help with Something Specific?</h2>
            <p className="mb-6">
              If you'd like us to create a tutorial for a specific feature or use case, 
              please let us know by contacting our support team.
            </p>
            <Link 
              to="/support"
              className="inline-flex items-center px-4 py-2 bg-roundone-purple text-white rounded-md hover:bg-roundone-light-purple transition-colors"
            >
              Request a Tutorial
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Tutorials; 